module.exports = __webpack_public_path__ + "img/yuyue_FB_button.40c49185.png";